import { Vue, Component } from "vue-property-decorator";
@Component
export default class RequestPromises extends Vue {
  public requestPromises: { [hash: string]: number } = {};
  public beforeDestroy() {
    if (!this.$_.isEmpty(this.requestPromises))
      this.$store.commit("api/cancelRequests", this.requestPromises);
  }
}
